import angular from 'angular';
import { debounce } from 'data/function';
import { isEmpty } from 'data/string';
import { ChannelsFeatures } from 'modules/application/detail/channels/ChannelsFeatures';
import { homeName } from 'modules/application/detail/home';
import { APPLICATION_LIST_NAME, MarketplaceFeatures } from 'modules/application/marketplace/MarketplaceFeatures';
import { Contexts } from 'modules/core/ContextProcessorService';
import { ConfirmationModal } from 'modules/ui';
import { ChannelsNames } from '../../detail/channels/Channels';
import { marketplaceListStateName } from '../list';
import './MarketplaceStep.scss';
import { MarketplaceTemplate } from './MarketplaceTemplate';
export const MASTER_TEMPLATE = 'master';
export const MAX_LENGHT = 8;
const CODE_REPEATED_NAME = 21;
const CODE_NO_PERMISSION = 66;
const FAILURE_STATUS = 'failure';
const BLIP_STORE_ORIGIN = 'blip-store';
const BLIP_STORE_TEMPLATES_PATH = '/blip-store/templates';
const marketplaceSolutionspackageUploaded = 'marketplace-solutionspackage-uploaded';
const marketplaceSolutionspackageDownloaded = 'marketplace-solutionspackage-downloaded';
const marketplaceSolutionspackageDownloadFailed = 'marketplace-solutionspackage-download-failed';
const marketplaceSolutionspackageClosed = 'marketplace-solutionspackage-closed';
const marketplaceSolutionspackageDownload = 'marketplace-solutionspackage-download';
export class MarketplaceStepController {
    static $inject = ['$state', '$document', 'LoadingService', 'ApplicationService2', 'SharedToastsService', 'BlipToastService', 'SavingService', 'ModalService', 'TenantService', '$translate', 'MarketplaceService', 'APPLICATION_DEFAULT_IMAGE', 'ContextProcessorService', '$window', '$timeout', 'AccountService2', 'SegmentService', '$location', '$rootScope', 'MEDIA_PROFILE_FOR_AVATARS'];
    constructor($state, $document, LoadingService, ApplicationService2, SharedToastsService, BlipToastService, SavingService, ModalService, TenantService, $translate, MarketplaceService, APPLICATION_DEFAULT_IMAGE, ContextProcessorService, $window, $timeout, AccountService2, SegmentService, $location, $rootScope, MEDIA_PROFILE_FOR_AVATARS) {
        'ngInject';
        this.$state = $state;
        this.$document = $document;
        this.LoadingService = LoadingService;
        this.ApplicationService2 = ApplicationService2;
        this.SharedToastsService = SharedToastsService;
        this.BlipToastService = BlipToastService;
        this.SavingService = SavingService;
        this.ModalService = ModalService;
        this.TenantService = TenantService;
        this.$translate = $translate;
        this.MarketplaceService = MarketplaceService;
        this.APPLICATION_DEFAULT_IMAGE = APPLICATION_DEFAULT_IMAGE;
        this.ContextProcessorService = ContextProcessorService;
        this.$window = $window;
        this.$timeout = $timeout;
        this.AccountService2 = AccountService2;
        this.SegmentService = SegmentService;
        this.$location = $location;
        this.$rootScope = $rootScope;
        this.MEDIA_PROFILE_FOR_AVATARS = MEDIA_PROFILE_FOR_AVATARS;
        this.isInstagramEnabled = false;
        this.selectedTags = [];
        this.isEditingName = false;
        this.isEditingHelpCenterUrl = false;
        this.templateIdentity = '';
        this.isEditingTemplate = false;
        this.newTemplate = true;
        this.isLoading = false;
        this.isLoadingSubBots = false;
        this.isSavingTemplate = false;
        this.tagsOnFocus = false;
        this.nameOnFocus = false;
        this.languageOnFocus = false;
        this.helpCenterUrlOnFocus = false;
        this.canAddItems = true;
        this.isInvalidTags = false;
        this.invalidName = false;
        this.invalidLanguage = false;
        this.invalidHelpCenterUrl = false;
        this.canCreateTemplateHeadstart = false;
        this.canEditDeleteTemplateHeadstart = false;
        this.canControlTemplateVisibility = false;
        this.isOwner = false;
        this.templateNewName = '';
        this.domainList = [];
        this.emailList = [];
        this.domainValidity = true;
        this.emailValidity = true;
        this.domainRegex = /@[a-zA-Z]+\.[a-zA-Z]+/;
        this.emailRegex = /^(.+)@(\S+)$/;
        this.plans = {
            standard: {
                id: '00892f5b-0404-40d5-8c1f-a57b7f709877',
                name: 'standard',
                active: true,
            },
            start: {
                id: '43f60cb5-173e-4790-8d90-55aac9991267',
                name: 'start',
                active: false,
            },
            business: {
                id: '2c0c288f-9dee-46b5-a2ab-1529a132def1',
                name: 'business',
                active: false,
            },
            enterprise: {
                id: '7bb2ad52-66bd-4608-9a44-5995c6aa0780',
                name: 'enterprise',
                active: false,
            },
        };
        this.channels = {
            blipChat: {
                name: ChannelsNames.Blipchat,
                active: true,
            },
            whatsapp: {
                name: ChannelsNames.WhatsApp,
                active: false,
            },
            messenger: {
                name: ChannelsNames.Messenger,
                active: false,
            },
            telegram: {
                name: ChannelsNames.Telegram,
                active: false,
            },
            workplace: {
                name: ChannelsNames.Workplace,
                active: false,
            },
            email: {
                name: ChannelsNames.Mailgun,
                active: false,
            },
            applebusinesschat: {
                name: ChannelsNames.AppleBusinessChat,
                active: false,
            },
            instagram: {
                name: ChannelsNames.Instagram,
                active: false,
            },
        };
        this.editedApplication = {
            router: {},
            subbots: [],
        };
        this.getCheckedBoxStandard = async (event) => {
            this.setHeadstartPlans(this.plans.standard, event.detail.checked);
        };
        this.getCheckedBoxStart = async (event) => {
            this.setHeadstartPlans(this.plans.start, event.detail.checked);
        };
        this.getCheckedBoxBusiness = async (event) => {
            this.setHeadstartPlans(this.plans.business, event.detail.checked);
        };
        this.getCheckedBoxEnterprise = async (event) => {
            this.setHeadstartPlans(this.plans.enterprise, event.detail.checked);
        };
        this.validateDomain = async (event) => {
            const domainInput = document.getElementById('domainChipInput');
            let validity = true;
            if (event.detail.data.length > 0) {
                event.detail.data.forEach((domain) => {
                    if (!this.domainRegex.test(domain)) {
                        validity = false;
                    }
                });
            }
            else {
                return;
            }
            if (validity) {
                this.domainValidity = true;
                this.marketplaceTemplate.allowedDomains = event.detail.data;
                domainInput.removeAttribute('danger');
            }
            else {
                this.domainValidity = false;
                domainInput.setAttribute('danger', 'true');
            }
        };
        this.validateEmail = async (event) => {
            const emailInput = document.getElementById('emailChipInput');
            let validity = true;
            if (event.detail.data.length > 0) {
                event.detail.data.forEach((email) => {
                    if (!this.emailRegex.test(email)) {
                        validity = false;
                    }
                });
            }
            else {
                return;
            }
            if (validity) {
                this.emailValidity = true;
                this.marketplaceTemplate.allowedEmails = event.detail.data;
                emailInput.removeAttribute('danger');
            }
            else {
                this.emailValidity = false;
                emailInput.setAttribute('danger', 'true');
            }
        };
        this.templateIdentity = $state.params?.templateIdentity;
        this.onChangeExtrasPropertyDebounced = debounce(this.validateDomain, 250);
    }
    async loadTemplate() {
        this.marketplaceTemplate = new MarketplaceTemplate();
        if (this.templateIdentity &&
            this.MarketplaceService.getTemplateBuffer()) {
            this.editingTemplate = this.MarketplaceService.getTemplateBuffer();
        }
        if (!this.editingTemplate) {
            this.isEditingName = true;
            this.isEditingTemplate = false;
        }
        else {
            this.isEditingTemplate = true;
        }
        this.noSearchResults = false;
    }
    $onInit() {
        this.loadMarketplace();
    }
    setBeforeUnloadEvent() {
        this.$window.onbeforeunload = this.alertPendingChanges.bind(this, true);
    }
    removePageEvents() {
        this.$window.removeEventListener('onbeforeunload', this.alertPendingChanges.bind(this, true));
    }
    async loadMarketplace() {
        await this.checkFeatures();
        await this.loadTemplate();
        await this.getMarketplaceChannels();
        this.getVisibilityData();
        this.loadRouters();
    }
    getVisibilityData() {
        if (this.isEditingTemplate) {
            if (this.editingTemplate.allowedDomains.length > 0) {
                this.marketplaceTemplate.allowedDomains = this.editingTemplate.allowedDomains.split(',');
            }
            if (this.editingTemplate.allowedEmails.length > 0) {
                this.marketplaceTemplate.allowedEmails = this.editingTemplate.allowedEmails.split(',');
            }
        }
    }
    async getMarketplaceChannels() {
        if (!this.editingTemplate) {
            this.marketplaceTemplate.channels.push('blipChat');
            this.marketplaceTemplate.plans =
                '00892f5b-0404-40d5-8c1f-a57b7f709877';
            this.setHeadstartPlans(this.plans.standard, true);
            const account = await this.AccountService2.me();
            this.marketplaceTemplate.language = account.culture;
        }
        else {
            const editedChannels = this.editingTemplate.channels.split(',');
            editedChannels.forEach((channel) => {
                for (const [key, value] of Object.entries(this.channels)) {
                    if (value.name === channel &&
                        channel.toLowerCase() !==
                            this.channels.blipChat.name.toLowerCase()) {
                        this.setHeadstartChannel(value);
                        continue;
                    }
                }
            });
            if (this.editingTemplate.plans) {
                for (const [, value] of Object.entries(this.plans)) {
                    if (value.id === this.editingTemplate.plans) {
                        this.setHeadstartPlans(value, true, true);
                        continue;
                    }
                }
            }
            else {
                this.setHeadstartPlans(this.plans.standard, true);
            }
            this.marketplaceTemplate = { ...this.editingTemplate };
            this.marketplaceTemplate.channels = editedChannels.join(',');
            this.marketplaceTemplate.tags = this.editingTemplate.tags.split(',');
            this.marketplaceTemplate.language = this.marketplaceTemplate
                .language
                ? this.marketplaceTemplate.language
                : 'pt-BR';
            this.marketplaceTemplate.description = this.editingTemplate.description
                .split('\\n')
                .join('\n');
            this.marketplaceTemplate.tags.forEach(tag => {
                this.selectedTags.push({
                    background: '#2cc3d5',
                    canChangeBackground: false,
                    label: tag,
                });
            });
        }
        this.isOwner =
            (await this.AccountService2.me()).identity ===
                this.marketplaceTemplate.ownerIdentity;
    }
    async checkFeatures() {
        try {
            this.canCreateTemplateHeadstart = await MarketplaceFeatures.isCreateHeadstartTemplateEnabled();
            this.canEditDeleteTemplateHeadstart = await MarketplaceFeatures.isEditDeleteHeadstartTemplateEnabled();
            this.canControlTemplateVisibility = await MarketplaceFeatures.isTemplateVisibilityEnabled();
            const isCreatingNewTemplate = !this.templateIdentity;
            if (!this.canCreateTemplateHeadstart && isCreatingNewTemplate) {
                this.$state.go(APPLICATION_LIST_NAME);
                return;
            }
            this.isOrganizationEnabled = await this.TenantService.isOrganizationEnabled();
            this.tenantId =
                this.ContextProcessorService.context === Contexts.Tenants
                    ? this.ContextProcessorService.tenant.id
                    : undefined;
        }
        catch (e) {
            console.error(e);
            throw e;
        }
        const featurePromises = [];
        featurePromises.push(ChannelsFeatures.isInstagramEnabled());
        [
            this.isInstagramEnabled,
        ] = await Promise.all(featurePromises);
    }
    async loadRouters() {
        if (!this.isEditingTemplate) {
            try {
                if (this.isOrganizationEnabled) {
                    const tenantId = this.ContextProcessorService.tenant.id;
                    await this.ContextProcessorService.waitForInitialization();
                    try {
                        if (this.ContextProcessorService.context ===
                            Contexts.Default) {
                            await this.loadMarketplaceRouter(tenantId);
                            this.LoadingService.stopLoading();
                            return;
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                    finally {
                        this.loadMarketplaceRouter(tenantId);
                    }
                }
                else {
                    this.loadMarketplaceRouter();
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        else {
            this.loadMarketplaceRouterForEdit();
        }
    }
    async loadMarketplaceRouter(tentantId) {
        let appList;
        this.isLoading = true;
        this.LoadingService.startLoading();
        await this.ApplicationService2.getApplications(tentantId)
            .then(appData => {
            appList = appData;
        })
            .catch(async (e) => {
            this.LoadingService.stopLoading();
            const errorResponse = JSON.parse(e);
            this.BlipToastService.show('danger', {
                title: await this.$translate('createApplication.errorMsg.title'),
                msg: errorResponse.reason.description,
            });
            this.$state.go(marketplaceListStateName, {
                from: 'Error',
            });
            return;
        });
        if (!appList) {
            this.isLoading = false;
            this.LoadingService.stopLoading();
            return;
        }
        const filteredAppList = appList.filter(item => {
            return item.template === MASTER_TEMPLATE;
        });
        for await (const item of filteredAppList) {
            item.applicationJson = [];
            item.activated = false;
            item.imageUri = item.imageUri
                ? item.imageUri
                : this.APPLICATION_DEFAULT_IMAGE;
            item.hasRouterChild = false;
        }
        this.applications = filteredAppList.map(application => {
            return { ...application };
        });
        this.isLoading = false;
        this.LoadingService.stopLoading();
    }
    async loadMarketplaceRouterForEdit() {
        this.isLoading = true;
        try {
            await this.AccountService2.connect();
            const editedRouter = await this.AccountService2.get(this.marketplaceTemplate.router, 'msging.net');
            this.editedApplication.router = { ...editedRouter };
            const editedSubbots = this.marketplaceTemplate.subBots.split(',');
            editedSubbots.map(async (bot) => {
                const response = await this.AccountService2.get(bot, 'msging.net');
                this.editedApplication.subbots.push({ ...response });
            });
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.isLoading = false;
        }
    }
    isNotEmptyChildren(item) {
        return item.length !== 0;
    }
    async activateAccordion(item) {
        this.applications.forEach(element => {
            if (element.shortName !== item.shortName) {
                element.activated = false;
            }
        });
        if (!item.activated) {
            item.activated = true;
            this.marketplaceTemplate.router = item.shortName;
            await this.loadSubBotsInformationAsync(item);
            const subBots = item.applicationJson.settings.children.map(child => child.shortName);
            this.marketplaceTemplate.subBots = subBots;
        }
        else {
            item.activated = false;
            this.marketplaceTemplate.router = '';
            this.marketplaceTemplate.subBots = [];
        }
    }
    async loadSubBotsInformationAsync(item) {
        this.isLoadingSubBots = true;
        try {
            const response = await this.ApplicationService2.getApplicationJSON(item.shortName);
            item.applicationJson = response ? response.applicationJson : [];
            if (item.applicationJson.settings?.children.length) {
                for await (const child of item.applicationJson.settings
                    ?.children) {
                    await this.ApplicationService2.getApplication(child.shortName)
                        .then(applicationData => {
                        child.applicationData = applicationData;
                        child.imageUri =
                            applicationData.imageUri ||
                                this.APPLICATION_DEFAULT_IMAGE;
                        if (!item.hasRouterChild &&
                            child?.applicationData.template ===
                                MASTER_TEMPLATE) {
                            item.hasRouterChild = true;
                        }
                        if (!applicationData) {
                            item.applicationJson.settings.children = item.applicationJson.settings.children.filter(item => item.shortName !== child.shortName);
                        }
                    })
                        .catch(e => {
                        const errorResponse = JSON.parse(e);
                        child.hasPermission =
                            errorResponse?.status === FAILURE_STATUS &&
                                errorResponse?.CODE === CODE_NO_PERMISSION; //for an eventual permission validation
                    });
                }
            }
        }
        finally {
            this.isLoadingSubBots = false;
        }
    }
    clearSearch() {
        this.searchText = '';
        this.searchChange();
    }
    isClearAvailable() {
        return this.searchText?.length > 0;
    }
    async fileUploaded(file) {
        try {
            if (!file) {
                throw 'error';
            }
            this.LoadingService.startLoading();
            this.marketplaceTemplate.imageUrl = await this.ApplicationService2.uploadFile(file, { profile: this.MEDIA_PROFILE_FOR_AVATARS });
        }
        catch (err) {
            console.error(err);
            this.SharedToastsService.showUploadErrorToast(err.status);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    startEditingName() {
        this.isEditingName = true;
    }
    cancelEditingName() {
        if (!this.marketplaceTemplate.name) {
            this.invalidName = true;
        }
        this.isEditingName = false;
    }
    isEditingMode() {
        return this.isEditingTemplate;
    }
    finishEditingName() {
        if (!this.marketplaceTemplate.name) {
            this.invalidName = true;
            return;
        }
        if (this.marketplaceTemplate.name?.length) {
            try {
                this.LoadingService.startLoading();
            }
            catch (error) {
                console.error(error);
            }
            finally {
                this.isEditingName = false;
                this.LoadingService.stopLoading();
            }
        }
    }
    searchChange() {
        if (!this.applicationsBuffer) {
            this.applicationsBuffer = angular.copy(this.applications);
        }
        if (this.searchText.length >= 3 || this.searchText.length == 0) {
            this.isLoading = true;
            const searchResults = this.applicationsBuffer.filter(x => x.name.toLowerCase().includes(this.searchText));
            if (searchResults.length > 0) {
                this.applications = searchResults;
            }
            else {
                this.applications = [];
                this.noSearchResults = true;
            }
        }
        else {
            this.applications = this.applicationsBuffer;
            this.applicationsBuffer = undefined;
        }
        this.isLoading = false;
    }
    setHeadstartChannel(channel) {
        const hasChannelAdded = this.marketplaceTemplate.channels.find(item => item === channel.name);
        if (!hasChannelAdded) {
            this.marketplaceTemplate.channels.push(channel.name);
        }
        else {
            this.marketplaceTemplate.channels = this.marketplaceTemplate.channels.filter(item => item !== hasChannelAdded || item.name === 'blipChat');
        }
        channel.active = !channel.active;
    }
    setHeadstartPlans(plan, checked, showData = false) {
        if (checked && (!this.isEditingTemplate || showData)) {
            this.marketplaceTemplate.plans = plan.id;
            this.plans.standard.active = this.plans.standard.id == plan.id;
            this.plans.business.active = this.plans.business.id == plan.id;
            this.plans.start.active = this.plans.start.id == plan.id;
            this.plans.enterprise.active = this.plans.enterprise.id == plan.id;
        }
    }
    handleNameOnFocus() {
        this.nameOnFocus = true;
    }
    handleLanguageOnFocus() {
        this.languageOnFocus = true;
    }
    handleHelpCenterUrlOnFocus() {
        this.helpCenterUrlOnFocus = true;
    }
    handleHelpCenterUrlOnClick() {
        if (this.marketplaceTemplate.helpCenterUrl && this.isEditingTemplate) {
            window.open(this.marketplaceTemplate.helpCenterUrl, '_blank');
        }
    }
    handleNameOnBlur() {
        this.nameOnFocus = false;
        if (!this.marketplaceTemplate.name) {
            this.invalidName = true;
            return;
        }
        if (this.marketplaceTemplate.name?.length) {
            if (this.validateApplicationName(this.marketplaceTemplate.name.toLocaleLowerCase())) {
                this.invalidName = false;
            }
        }
    }
    handleLanguageOnBlur() {
        this.languageOnFocus = false;
        if (!this.marketplaceTemplate.language) {
            this.invalidLanguage = true;
            return;
        }
        if (this.marketplaceTemplate.language?.length) {
            if (this.validateApplicationName(this.marketplaceTemplate.language.toLocaleLowerCase())) {
                this.invalidLanguage = false;
            }
        }
    }
    handleHelpCenterUrlOnBlur() {
        this.helpCenterUrlOnFocus = false;
        if (!this.marketplaceTemplate.helpCenterUrl) {
            this.invalidHelpCenterUrl = true;
            return;
        }
        if (this.marketplaceTemplate.helpCenterUrl?.length) {
            if (this.validateApplicationName(this.marketplaceTemplate.helpCenterUrl.toLocaleLowerCase())) {
                this.invalidHelpCenterUrl = false;
            }
        }
    }
    handleTagsOnFocus() {
        this.tagsOnFocus = true;
    }
    handleTagsOnBlur() {
        this.tagsOnFocus = false;
    }
    updateTagsInput() {
        this.canAddItems = this.selectedTags.length < MAX_LENGHT;
        this.isInvalidTags = this.selectedTags.length === 0;
        if (this.selectedTags.length) {
            this.marketplaceTemplate.tags = [];
            this.selectedTags?.map(tag => {
                this.marketplaceTemplate.tags.push(tag.label);
            });
        }
        else {
            this.marketplaceTemplate.tags = this.selectedTags;
        }
    }
    validateApplicationName(name) {
        const letterFirstPosition = /(^[a-zA-Z])/;
        if (!letterFirstPosition.exec(name)) {
            return false;
        }
        return true;
    }
    visibilityValidity() {
        return this.domainValidity && this.emailValidity;
    }
    async save() {
        this.isSavingTemplate = true;
        if (this.marketplaceTemplate.subBots.length <= 0) {
            const errorRouter = await this.$translate('marketplace.create.errors.subbots');
            this.BlipToastService.show('danger', {
                title: await this.$translate('createApplication.errorMsg.noSubBots'),
                msg: errorRouter,
            });
            this.isSavingTemplate = false;
            return;
        }
        let isValidSolutionPackage = true;
        if (!this.validateApplicationName(this.marketplaceTemplate.name.toLocaleLowerCase())) {
            this.invalidName = true;
            this.BlipToastService.show('danger', {
                title: await this.$translate('createApplication.errorMsg.title'),
                msg: await this.$translate('marketplace.create.errors.invalidName'),
            });
            this.isSavingTemplate = false;
            return;
        }
        else {
            this.invalidName = false;
        }
        if (isEmpty(this.marketplaceTemplate.router)) {
            const errorRouter = await this.$translate('marketplace.create.errors.router');
            this.BlipToastService.show('danger', {
                title: await this.$translate('createApplication.errorMsg.title'),
                msg: errorRouter,
            });
            this.isSavingTemplate = false;
            return;
        }
        if (isEmpty(this.marketplaceTemplate.subBots)) {
            const errorRouter = await this.$translate('marketplace.create.errors.router');
            this.BlipToastService.show('danger', {
                title: await this.$translate('createApplication.errorMsg.noSubBots'),
                msg: errorRouter,
            });
            this.isSavingTemplate = false;
            return;
        }
        if (!this.marketplaceTemplate.channels.length) {
            const errorChannel = await this.$translate('marketplace.create.errors.channels');
            this.BlipToastService.show('danger', {
                title: await this.$translate('createApplication.errorMsg.title'),
                msg: errorChannel,
            });
            this.isSavingTemplate = false;
            return;
        }
        if (!this.marketplaceTemplate.plans.length) {
            const errorChannel = await this.$translate('marketplace.create.errors.plans');
            this.BlipToastService.show('danger', {
                title: await this.$translate('createApplication.errorMsg.title'),
                msg: errorChannel,
            });
            this.isSavingTemplate = false;
            return;
        }
        if (!this.selectedTags.length) {
            const errorTags = await this.$translate('marketplace.create.errors.tags');
            this.BlipToastService.show('danger', {
                title: await this.$translate('createApplication.errorMsg.title'),
                msg: errorTags,
            });
            this.updateTagsInput();
        }
        if (this.headstartForm.$valid && this.validateFormInputs()) {
            const objectToSave = { ...this.marketplaceTemplate };
            objectToSave.tags = this.marketplaceTemplate.tags.join(',');
            objectToSave.subBots = objectToSave.subBots.join(',');
            objectToSave.channels = objectToSave.channels.join(',');
            objectToSave.allowedDomains = objectToSave.allowedDomains.join();
            objectToSave.allowedEmails = objectToSave.allowedEmails.join();
            objectToSave.description = objectToSave.description.replace(/\n/g, '\\n');
            delete objectToSave.image;
            this.SavingService.startSaving();
            try {
                const newMarketplaceRegister = await this.MarketplaceService.saveTemplateHeadstart(objectToSave);
                if (newMarketplaceRegister.status === FAILURE_STATUS) {
                    isValidSolutionPackage = false;
                    let message = newMarketplaceRegister.reason.description;
                    if (message.includes('Missing configuration:')) {
                        const shortName = message
                            .replace('Missing configuration: ', '')
                            .replace('@msging.net', '');
                        message = await this.$translate('marketplace.create.errors.notPublished', { shortName });
                    }
                    this.BlipToastService.show('danger', {
                        msg: message,
                    });
                }
                if (newMarketplaceRegister.reason?.code === CODE_REPEATED_NAME) {
                    isValidSolutionPackage = false;
                    this.templateNewName =
                        newMarketplaceRegister.reason.description;
                    this.toggleVariablesAlert();
                }
            }
            catch (e) {
                this.BlipToastService.show('danger', { msg: e.message });
            }
            finally {
                if (isValidSolutionPackage) {
                    const successMsg = await this.$translate('marketplace.create.success.successMsg');
                    const payload = await this.createTrackingObject(this.marketplaceTemplate);
                    this.createTracking(marketplaceSolutionspackageUploaded, payload);
                    this.SavingService.stopSaving();
                    this.$state.go(marketplaceListStateName, {
                        from: 'Create Chatbot Button',
                    });
                    this.BlipToastService.show('success', {
                        msg: successMsg,
                    });
                }
                this.isSavingTemplate = false;
            }
        }
    }
    async downloadMarketplaceTemplate() {
        const payloadDownload = await this.createTrackingObject(this.marketplaceTemplate);
        this.createTracking(marketplaceSolutionspackageDownload, payloadDownload);
        this.toggleMarketplaceDownloadAlert();
        this.LoadingService.startLoading();
        this.setBeforeUnloadEvent();
        try {
            await this.AccountService2.refreshUser();
            const token = await this.AccountService2.getAccountToken();
            const tenantId = this.ContextProcessorService.context === Contexts.Tenants
                ? this.ContextProcessorService.tenant.id
                : undefined;
            const planId = tenantId
                ? (await this.AccountService2.getTenantPlan(tenantId)).id
                : (await this.AccountService2.getActiveSubscription()).planId;
            const marketplaceTemplate = await this.MarketplaceService.downloadTemplate(this.marketplaceTemplate.id, planId, token, tenantId);
            const { router } = marketplaceTemplate;
            const payload = await this.createTrackingObject(marketplaceTemplate);
            this.createTracking(marketplaceSolutionspackageDownloaded, payload);
            const parsed = this.marketplaceTemplate.name
                .normalize('NFD')
                .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '')
                .replace(' ', '')
                .toLowerCase();
            this.createTracking(`appcues-template-${parsed}`, payload);
            this.close(false);
            const schema = JSON.parse(marketplaceTemplate.schema);
            if (!!schema.Plugins && !!schema.Plugins['configuration-plugin']) {
                this.$timeout(() => {
                    this.$location.path(`/application/detail/${router}/plugin/configuration-plugin`);
                });
            }
            else {
                this.$state.go(homeName, { shortName: router });
            }
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                title: await this.$translate('createApplication.errorMsg.title'),
                msg: await this.$translate('marketplace.download.error'),
            });
            this.createTracking(marketplaceSolutionspackageDownloadFailed, {
                error: e.message,
                packageName: this.marketplaceTemplate.name,
            });
            return;
        }
        finally {
            this.LoadingService.stopLoading();
            this.toggleMarketplaceDownloadAlert();
            this.removePageEvents();
        }
    }
    async createTrackingObject(marketplaceTemplate) {
        const accountId = (await this.AccountService2.me()).identity;
        const trackingObject = {
            clientId: accountId,
            packageName: this.marketplaceTemplate.name,
            channels: marketplaceTemplate.channels,
            router: marketplaceTemplate.router,
            tags: marketplaceTemplate.tags,
        };
        return trackingObject;
    }
    alertPendingChanges(isWindowClosing, e) {
        this.LoadingService.stopLoading();
        const message = this.$translate.instant('modules.application.detail.persistentMenu.confirmationMessage');
        if (!isWindowClosing && !e.defaultPrevented && !confirm(message)) {
            e.preventDefault();
            return;
        }
        e.returnValue = message;
        return message;
    }
    async toggleVariablesAlert() {
        const bdsAlert = document.querySelector('bds-alert[id=marketplace-name-alert]');
        await bdsAlert.toggle();
    }
    async toggleMarketplaceDownloadAlert() {
        const bdsAlert = document.querySelector('bds-alert[id=marketplace-download-alert]');
        await bdsAlert.toggle();
    }
    async editTemplate() {
        this.isEditingTemplate = false;
        this.newTemplate = false;
        this.marketplaceTemplate.channels = this.marketplaceTemplate.channels.split(',');
        this.marketplaceTemplate.subBots = this.marketplaceTemplate.subBots.split(',');
    }
    async confirmDeleteModal() {
        const title = await this.$translate('modules.application.detail.edit.confirmDeleteTitle');
        const body = await this.$translate('marketplace.delete.body');
        const confirm = await this.$translate('utils.forms.delete');
        const cancel = await this.$translate('utils.forms.cancel');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: title,
            },
            body: body,
            buttons: {
                confirm: {
                    text: confirm,
                    class: 'bp-btn bp-btn--delete bp-btn--small',
                },
                cancel: {
                    text: cancel,
                },
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            await this.delete();
        }
    }
    async delete() {
        this.LoadingService.startLoading();
        try {
            // Delete application on Iris server
            await this.MarketplaceService.removeTemplate(this.marketplaceTemplate.id);
        }
        catch (err) {
            this.BlipToastService.show('danger', {
                msg: await this.$translate('marketplace.delete.error'),
            });
            this.LoadingService.stopLoading();
            return;
        }
        this.LoadingService.stopLoading();
        if (this.shouldReturnToBlipStore()) {
            this.$location.path(BLIP_STORE_TEMPLATES_PATH).search({});
            return;
        }
        this.$state.go('auth.marketplace.list');
    }
    async renameMarketplaceName() {
        this.isEditingName = true;
        this.toggleVariablesAlert().then(() => {
            this.$timeout(() => {
                const templateName = this.$window.document.getElementById('templateName');
                templateName?.focus();
            });
        });
    }
    updateMarketplaceId() {
        this.marketplaceTemplate.name = this.templateNewName;
        this.toggleVariablesAlert().then(() => {
            this.save();
        });
    }
    async toggleDisconnectAlert() {
        const bdsAlert = document.querySelector('bds-alert[id=messenger-disconnect-application]');
        await bdsAlert.toggle();
    }
    validateFormInputs() {
        return (this.validateApplicationName(this.marketplaceTemplate.name?.toLocaleLowerCase()) &&
            this.marketplaceTemplate.channels.length &&
            this.selectedTags.length !== 0);
    }
    $onDestroy() {
        this.$document.off('keydown');
    }
    async close(isCloseEvent = true) {
        this.$onDestroy();
        if (isCloseEvent) {
            const payload = await this.createTrackingObject(this.marketplaceTemplate);
            this.createTracking(marketplaceSolutionspackageClosed, payload);
            if (this.shouldReturnToBlipStore()) {
                this.$location.path(BLIP_STORE_TEMPLATES_PATH).search({});
                return;
            }
        }
        this.$state.go('auth.marketplace.list');
    }
    async createTracking(tracking, payload) {
        this.SegmentService.createTrack(tracking, payload);
    }
    shouldReturnToBlipStore() {
        return this.$state.params?.origin === BLIP_STORE_ORIGIN;
    }
}
MarketplaceStepController.$inject = ['$state', '$document', 'LoadingService', 'ApplicationService2', 'SharedToastsService', 'BlipToastService', 'SavingService', 'ModalService', 'TenantService', '$translate', 'MarketplaceService', 'APPLICATION_DEFAULT_IMAGE', 'ContextProcessorService', '$window', '$timeout', 'AccountService2', 'SegmentService', '$location', '$rootScope', 'MEDIA_PROFILE_FOR_AVATARS'];
